/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const categoriesModule = require('@utils/categories/categoriesModule');
const cmsModule = require('@utils/cms/cmsModule');
const commonModule = require('@utils/common/commonModule');
const consumersModule = require('@utils/consumers/consumersModule');
const getFetchModule = require('@utils/get_fetch/getFetchModule');
const FiltersService = require('./filtersService');
const FiltersSortByService = require('./sortBy/filtersSortByService');
const rangeNumberFilterDirective = require('./components/rangeNumber/rangeNumberFilterDirective');
const defaultCheckboxesFilterDirective = require('./components/checkboxes/defaultCheckboxesFilterDirective');
const checkboxesFilterDirective = require('./components/checkboxes/checkboxesFilterDirective');
const filtersSortByDirective = require('./sortBy/filtersSortByDirective');
const fullPageFiltersDirective = require('./fullPageFilters/fullPageFiltersDirective');
const filtersMenuDirective = require('./components/filtersMenu/filtersMenuDirective');
const desktopFiltersDirective = require('./desktopFilters/desktopFiltersDirective');
const mobileFiltersDirective = require('./mobileFilters/mobileFiltersDirective');

const filtersModule = angular
    .module('enervee_utils.filters', [
        categoriesModule.name,
        cmsModule.name,
        commonModule.name,
        consumersModule.name,
        getFetchModule.name,
    ])
    .factory('FiltersService', FiltersService)
    .factory('FiltersSortByService', FiltersSortByService)
    .directive('defaultCheckboxesFilter', defaultCheckboxesFilterDirective)
    .directive('checkboxesFilter', checkboxesFilterDirective)
    .directive('rangeNumberFilter', rangeNumberFilterDirective)
    .directive('filtersSortBy', filtersSortByDirective)
    .directive('fullPageFilters', fullPageFiltersDirective)
    .directive('filtersMenu', filtersMenuDirective)
    .directive('mobileFilters', mobileFiltersDirective)
    .directive('desktopFilters', desktopFiltersDirective);

module.exports = filtersModule;